export const firstCharacterUpper = (string) => {
    if (string !== undefined && string !== null) {
        const sentence = string.toLowerCase().split(' ');
        for (let i = 0; i < sentence.length; i++) {
            if (sentence.length > 0 && sentence[i] === "") {
                continue;
            }
            sentence[i] = sentence[i][0].toUpperCase() + sentence[i].substring(1);
        }
        return sentence.join(' ');
    }
    return "";
}
